module.exports = __webpack_public_path__ + "static/media/dundee-sustainable-logo-colour.b345c4d3.svg";